import { render, staticRenderFns } from "./UIBlockListField.template.vue?vue&type=template&id=a1d77b64&scoped=true&"
var script = {}
import style0 from "./UIBlockListField.template.vue?vue&type=style&index=0&id=a1d77b64&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d77b64",
  null
  
)

export default component.exports